export const EN: Record<string, string> = {
  Home: "Home",
  "Resource Selected": "Resource Selected",
  "Resources List": "Resources List",
  List: "List",
  Resources: "Resources",
  "Find Colleague": "Find Colleague",
  Settings: "Settings",
  "Floor Plan": "Floor Plan",
  Locations: "Locations",
  Categories: "Categories",
  "Search resource name...": "Search resource name...",
  Calendar: "Calendar",
  "View Details": "View Details",
  "Add to My Favorites": "Add to My Favorites",
  Remove: "Remove",
  "Resource calendar": "Resource calendar",

  //Date
  Today: "Today",
  "Previous month": "Previous month",
  "Next month": "Next month",
  "Previous year": "Previous year",
  "Next year": "Next year",
  Close: "Close",
  "Field is required.": "Field is required.",
  "Invalid date format.": "Invalid date format.",
  S: "S",
  M: "M",
  T: "T",
  W: "W",
  F: "F",
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Apr",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Oct",
  Nov: "Nov",
  Dec: "Dec",
  st: "st",
  nd: "nd",
  rd: "rd",
  th: "th",
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sun: "Sun",
  Mon: "Mon",
  Tue: "Tue",
  Wed: "Wed",
  Thu: "Thu",
  Fri: "Fri",
  Sat: "Sat",
  Su: "Su",
  Mo: "Mo",
  Tu: "Tu",
  We: "We",
  Th: "Th",
  Fr: "Fr",
  Sa: "Sa",
  PM: "PM",
  AM: "AM",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "You cannot book this resource because your meeting request conflicts with the resource's booking policies.",
  "You need permissions to interact with this resource.":
    "You need permissions to interact with this resource.",
  Reason: "Reason",
  "The resource cannot be booked {{day}} days in advanced.":
    "The resource cannot be booked {{day}} day(s) in advanced.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "The end date of a recurring meeting cannot be more than {{day}} day(s) from today.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Meeting duration cannot be longer than {{time}} minutes long.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Meeting duration cannot be shorter than {{time}} minutes long.",
  "Booking policy": "Booking policy",
  Available: "Available ",
  Selected: "Selected",
  Booked: "Booked",
  Closed: "Closed",
  "Filter Options": "Filter Options",
  "{{resource}} is deleted": "{{resource}} is deleted.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "This resource can be booked but any occurrences with conflicts the resource will not be booked.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "This resource can be booked in advance for a maximum of {{day}} day(s), any occurrences beyond that limit will not be booked",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "This resource can be booked, but the meeting duration must be at least {{time}} minutes.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.",
  "Resource Name": "Resource Name",
  "Description ": "Description",
  "Resource Mail": "Resource Mail",
  Location: "Location",
  Capacity: "Capacity",
  Language: "Language",
  "Select an language": "Select an language",
  "Date/Time Format": "Date/Time Format",
  "First day of the week": "First day of the week",
  "Please select a first day": "Please select a first day",
  "Please select a time format": "Please select a time format",
  "Date Format": "Date Format",
  "Please select a date format": "Please select a date format",
  "Date Separator": "Date Separator",
  "Please select a date separator": "Please select a date separator",
  Apply: "Apply",
  "Default Location": "Default Location",
  Clear: "Clear",
  Help: "Help",
  Unavailable: "Unavailable",
  "No data available": "No data available",
  More: "More",
  "Available Floor Plans": "Available Floor Plans",
  "Default Categories": "Default Categories",
  "List more Resources": "List more Resources",
  Attendees: "Attendees",
  "Click on Further information to visit our support site":
    "Click on Further information to visit our support site",
  "New Order": "New Order",
  "Save default categories successfully": "Save default categories successfully",
  "Save config date/time successfully": "Save config date/time successfully",
  "Save language successfully": "Save language successfully",
  "Save default location successfully": "Save default location successfully",
  "And": "And",
  "Or": "Or",
  "Available occurrences of the series": "Available occurrences of the series",
  "Conflicting Occurrences": "Conflicting Occurrences",
  "Availability": "Availability",
  "Time Format": "Time Format",
  "You do not have permission to book this resource.": "You do not have permission to book this resource.",
  "This resource does not allow booking of recurring meetings.": "This resource does not allow booking of recurring meetings.",
  "You cannot book this resource.": "You cannot book this resource.",
  "Available Resources": "Available Resources"
};
